module.exports = __webpack_public_path__ + "img/wheel-base.2ab0f1fa.png";